import {
  Component,
  inject,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AuditLog } from '../../../../../shared/models/audit/audit-log';
import { ChangesTableComponent } from '../changes-table/changes-table.component';
import { AuditChangeDecorator } from './audit-change-decorator';
import { ErrorMessageApiService } from '../../../../services/api/error-message-api.service';
import { DtcApiService } from '../../../../services/api/dtc-api.service';
import { AuditLogQuery } from '../../../../../shared/models/audit/audit-log-query';
import { ScrollableBase } from '../../../base/scrollable-base';

@Component({
  selector: 'app-timeline',
  imports: [ChangesTableComponent],
  templateUrl: './timeline.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './timeline.component.scss',
})
export class TimelineComponent extends ScrollableBase<AuditLogQuery> implements OnInit, OnChanges {
  @Input() public auditLogs?: AuditLog[] = [];
  public decoratedAuditLogs: AuditLog[] = [];

  private injector = inject(Injector);

  public ngOnInit(): void {
    this.query = {
      parentEntityId: '',
      entityId: '',
    } as AuditLogQuery;
  }

  public async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!changes['auditLogs']) {
      return;
    }

    const decorator = this.createDecorator();
    await decorator.decorateChanges(this.auditLogs ?? [], (changes) => {
      this.decoratedAuditLogs = changes;
    });
  }

  public languageInfoStringForTranslation(auditLog: AuditLog): string {
    if (auditLog.entityName?.endsWith('Translation')) {
      return `Translation (${auditLog.languageCodeId})`;
    }
    return '';
  }

  private createDecorator(): AuditChangeDecorator {
    const service = Injector.create({
      providers: [
        {
          provide: AuditChangeDecorator,
          useClass: AuditChangeDecorator,
          deps: [ErrorMessageApiService, DtcApiService],
        },
      ],
      parent: this.injector,
    });

    return service.get(AuditChangeDecorator);
  }
}
